import React, { memo, useState, useCallback } from "react";
import { Post } from "@/core/types/postTypes";
import { PostCard } from "../PostCard";
import { PostOverlay } from "@/components/PostCard";

interface MinimalPostCardProps {
  post: Post;
  actions?: React.ReactNode;
}

/**
 * Minimal card: just the post media with badges.
 * Optional overlay actions shown on hover (e.g. schedule + remove from grid).
 *
 * Used by: Grid slots, available posts panel, drag overlay, client grid, idea links.
 */
export const MinimalPostCard: React.FC<MinimalPostCardProps> = memo(({ post, actions }) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = useCallback(() => setIsHovered(true), []);
  const handleMouseLeave = useCallback(() => setIsHovered(false), []);

  return (
    <PostCard
      post={post}
      viewMode="grid"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      overlayTopRight={
        actions && isHovered ? (
          <PostOverlay.TopRight>
            {actions}
          </PostOverlay.TopRight>
        ) : undefined
      }
    />
  );
});

MinimalPostCard.displayName = "MinimalPostCard";
